import axios from 'axios';
import { authHeader, getToken } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

const multipartHeader = () => ({
    headers: { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'multipart/form-data' }
});

export const getActiveEvents = () => axios.get(`${BASE_URL}/events`);
export const getEvent = (id) => axios.get(`${BASE_URL}/events/${id}`);
export const getAllEvents = () => axios.get(`${BASE_URL}/events/admin/all`, authHeader());
export const createEvent = (formData) => axios.post(`${BASE_URL}/events`, formData, multipartHeader());
export const updateEvent = (id, formData) => axios.put(`${BASE_URL}/events/${id}`, formData, multipartHeader());
export const deleteEvent = (id) => axios.delete(`${BASE_URL}/events/${id}`, authHeader());